import { Component, Element, getAssetPath, h, Host, Prop } from '@stencil/core';
import { logos } from '../../assets/shared/data/logo-names.data';
import { BREAKPOINTS } from '../../models/breakpoints.types';
import { Target, TARGETS } from '../../models/targets.types';
import { logoVariant } from './models/logo.types';

@Component({
  tag: 'wink-logo',
  styleUrl: 'styles/logo.default.scss',
  shadow: true,
})
export class Logo {
  @Element() host!: HTMLWinkLogoElement;

  @Prop() alt = '';
  @Prop() href = '';
  @Prop() target: Target = TARGETS.self;
  @Prop() appearance?: logoVariant = 'telenet-yellow';

  private getValidAppearance(): keyof typeof logos {
    const appearanceTyped = this.appearance as keyof typeof logos;
    return logos[appearanceTyped] ? appearanceTyped : 'telenet-yellow';
  }

  private getSrcDesktop() {
    const validAppearance = this.getValidAppearance();
    return logos[validAppearance]['desktop'] && getAssetPath(logos[validAppearance]['desktop']);
  }

  private getSrcMobile() {
    const validAppearance = this.getValidAppearance();
    const mobileSrc = logos[validAppearance]?.mobile ?? undefined;
    return mobileSrc ? getAssetPath(mobileSrc) : undefined;
  }

  private altText() {
    const validAppearance = this.getValidAppearance();
    return (this.alt !== 'Inspect element to check' && this.alt) || logos[validAppearance]['alt'];
  }

  private readonly renderLogoImage = (srcDesktop: string, srcMobile: string | undefined, alt: string) => {
    return (
      <picture>
        {srcMobile && <source srcSet={srcMobile} media={BREAKPOINTS.mobile} />}
        <img src={srcDesktop} alt={alt} />
      </picture>
    );
  };

  render() {
    return (
      <Host>
        {this.href.length > 0 ? (
          <a href={this.href} target={this.target}>
            {this.renderLogoImage(this.getSrcDesktop(), this.getSrcMobile(), this.altText())}
          </a>
        ) : (
          this.renderLogoImage(this.getSrcDesktop(), this.getSrcMobile(), this.altText())
        )}
      </Host>
    );
  }
}
